import {baseApi} from 'core/redux/store/api';
import {transformErrorResponse} from 'core/redux/store/api/utils';
import {IPersonalOffersData, IUserData} from 'modules/user/models';
import {API_VERSION} from 'core/helpers/env';
import {TResponse} from 'core/types';

/* eslint-disable sort-keys */
export const userApi = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getUser: builder.query<IUserData, void>({
            providesTags: ['User'],
            query: () => ({url: `${API_VERSION}/user`}),
            transformResponse: (response: {data: IUserData}) => response?.data,
            transformErrorResponse,
        }),
        getPersonalOffers: builder.query({
            query: () => {
                return {
                    url: `${API_VERSION}/prive/kp/personal-offers`,
                };
            },
            transformResponse: (response: TResponse<IPersonalOffersData>) => response?.data,
        }),
    }),
});

export const {
    useGetUserQuery,
    useGetPersonalOffersQuery,
    util: {getRunningQueriesThunk: getUserRunningQueriesThunk},
} = userApi;

export const {getUser} = userApi.endpoints;
